var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListingPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFF7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_25650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9131 34.7221C35.9131 34.725 35.9131 34.7278 35.9131 34.7314C33.029 37.3555 29.2003 38.954 25.0009 38.954C20.8007 38.954 16.9721 37.3555 14.0879 34.7314C14.0879 34.7278 14.0879 34.725 14.0879 34.7221C14.0879 30.3577 16.6334 26.5903 20.3156 24.832C21.6995 26.2168 23.3198 26.963 25.0009 26.963C26.6826 26.963 28.3023 26.2168 29.6868 24.832C33.369 26.5903 35.9131 30.3577 35.9131 34.7221Z",
    fill: "#FCCC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 11.0469C28.3337 11.0469 31.0364 13.7577 31.0364 17.1022C31.0364 20.4474 28.3337 25.0219 25.0001 25.0219C21.6666 25.0219 18.9639 20.4474 18.9639 17.1022C18.9639 13.7577 21.6666 11.0469 25.0001 11.0469Z",
    fill: "#FCD09F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_25650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2558,
    height: 27.907,
    fill: "white",
    transform: "translate(13.3721 11.0469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingPageIcon);
export default __webpack_public_path__ + "static/media/listingPageIcon.15ed4b8073605b3c942ed176d62287d6.svg";
export { ForwardRef as ReactComponent };